import { memo, useLayoutEffect } from 'react';
import { AppFrameProps, useAppFrame } from 'src/pages/AppFrameLayout';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface AppFrameConfigProps extends Partial<AppFrameProps> {}

export const AppFrameConfig: React.FC<AppFrameConfigProps & { id: string }> =
  memo(
    ({
      id,
      title,
      collapsedTitle,
      actions,
      row,
      frameOnly,
      drawerOpen,
      backButtonLinkTo,
      backButtonTitle,
      compactTitle,
      containerMaxWidth,
      customNavItems,
      fixedHeader,
      bgcolor,
      children,
      disabled,
    }) => {
      const { set, delete: deleteConfig } = useAppFrame();

      useLayoutEffect(() => {
        set(
          {
            ...(title && { title }),
            ...(collapsedTitle && { collapsedTitle }),
            ...(actions && { actions }),
            ...(row && { row }),
            ...(frameOnly && { frameOnly }),
            ...(drawerOpen && { drawerOpen }),
            ...(compactTitle && { compactTitle }),
            ...(children && { children }),
            ...(containerMaxWidth !== undefined && { containerMaxWidth }),
            ...(backButtonLinkTo && { backButtonLinkTo }),
            ...(backButtonTitle && { backButtonTitle }),
            ...(bgcolor && { bgcolor }),
            ...(disabled === true && { disabled }),
            ...(customNavItems && { customNavItems }),
            ...(fixedHeader && { fixedHeader }),
          },
          id
        );

        return () => {
          deleteConfig(id);
        };
      }, [
        title,
        collapsedTitle,
        actions,
        row,
        frameOnly,
        drawerOpen,
        compactTitle,
        containerMaxWidth,
        backButtonLinkTo,
        children,
        set,
        id,
        deleteConfig,
        backButtonTitle,
        bgcolor,
        disabled,
        fixedHeader,
        customNavItems,
      ]);

      return null;
    }
  );
